<div class="celo-dialog-header">
  <div class="title">Patient Lookup Results</div>
  <button
    class="celo-dialog-close"
    mat-icon-button
    aria-label="Close"
    [mat-dialog-close]="false"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr />
<div class="content">
  @if (!data) {
    <div class="fh">
      <app-empty-state
        [isLoading]="true"
        [diameter]="30"
        [message]="'Looking up patient data'"
      ></app-empty-state>
    </div>
  }
  @if (data) {
    <div>
      @if (data.length > 0) {
        <div>
          <div class="patient-info">
            @for (patient of data; track patient; let i = $index) {
              <div class="py-2">
                <div
                  matRipple
                  class="celo-cursor-pointer patientdata p-2 celo-hoverable"
                  (click)="
                    selectedIndex === i
                      ? (selectedIndex = undefined)
                      : (selectedIndex = i)
                  "
                >
                  <div>
                    <app-edit-patient
                      [patient]="patient"
                      [canSave]="false"
                      [editMode]="false"
                      [alignment]="'horizontal'"
                      [selectMode]="true"
                    ></app-edit-patient>
                  </div>
                  <div class="checkbox">
                    <mat-checkbox
                      class="no-pointer-events"
                      [checked]="selectedIndex === i"
                    ></mat-checkbox>
                  </div>
                </div>
              </div>
            }
          </div>
          <mat-dialog-actions align="end">
            <button
              class="celo-secondary-button"
              mat-button
              (click)="onNoClick()"
            >
              Cancel
            </button>
            <button
              [disabled]="!(selectedIndex >= 0)"
              class="celo-primary-button"
              mat-button
              (click)="onConfirm()"
            >
              Confirm
            </button>
          </mat-dialog-actions>
          <div cdkFocusInitial></div>
        </div>
      }
      @if (data.length === 0) {
        <div>
          <app-empty-state [isEmpty]="true" [message]="error"></app-empty-state>
        </div>
      }
    </div>
  }
</div>
